<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" />
    <div class="mt-header-nav">
      <DataList api="Department_List">
        <template v-slot:item="item">
          <news-card
            :data="item.obj"
            isKeShi
            titleField="name"
            descField="introduction"
            @click="toInfo(item.obj)"
          />
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import NewsCard from "@/components/NewsCard";

export default {
  components: {
    DataList,
    NewsCard,
  },
  data() {
    return {
      info: {},
    };
  },
  created() {
    this.isChoseDoctor = this.$route.query.type == "doctor";
    this.title = this.isChoseDoctor ? "选择科室" : "科室介绍";
    document.title = this.title;
  },
  methods: {
    toInfo(item) {
      if (this.isChoseDoctor) {
        this.$router.push({
          name: "hospitalDoctor",
          query: {
            DepartmentId: item.id,
          },
        });
      } else {
        this.$router.push({
          name: "hospitalDepartmentInfo",
          query: {
            Id: item.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
